import { render, staticRenderFns } from "./Columns.global.vue?vue&type=template&id=446276c0&"
import script from "./Columns.global.vue?vue&type=script&lang=js&"
export * from "./Columns.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports